import Application from "../../Application";
import CaseDecisionTypesPresenter, {
  ICaseDecisionTypesPresenter
} from "../presenter/CaseDecisionTypesPresenter";
import GetAllCaseDecisionTypesInteractor from "./GetAllCaseDecisionTypesInteractor";

export default class ShowCaseDecisionTypesInteractor {
  private application: Application;
  private output?: ICaseDecisionTypesPresenter;
  private getAllCaseDecisionTypesInteractor: GetAllCaseDecisionTypesInteractor;

  constructor({ application, getAllCaseDecisionTypes }) {
    this.application = application;
    this.getAllCaseDecisionTypesInteractor = getAllCaseDecisionTypes;
  }

  execute() {
    this.output = CaseDecisionTypesPresenter({
      application: this.application,

      initialState: { caseDecisionTypes: [] }
    });

    this.getAllCaseDecisionTypesInteractor
      .execute()
      .then(this.output.loadAllCaseDecisionTypes);
    return this.output;
  }
}
